export { default } from './RubberSaleCreateAndUpdateModal'
